import { useEffect, useMemo } from "react";
import { useLeaseCompStore, useLocationStore, useSaleCompStore } from "..";
import INearestLocation, { NearestLocationType } from "../interfaces/INearestLocation";

export default (nearestLocations: INearestLocation[], visible: boolean) => {
    const locationStore = useLocationStore();
    const leaseCompStore = useLeaseCompStore();
    const saleCompStore = useSaleCompStore();

    const locationIds = useMemo(() => nearestLocations.filter(l => l.type === NearestLocationType.Location).map(l => l.entityId), [nearestLocations]);
    const leaseCompIds = useMemo(() => nearestLocations.filter(l => l.type === NearestLocationType.LeaseComp).map(l => l.entityId), [nearestLocations]);
    const saleCompIds = useMemo(() => nearestLocations.filter(l => l.type === NearestLocationType.SaleComp).map(l => l.entityId), [nearestLocations]);

    useEffect(() => {
        if (visible) {
            locationStore.setRadiusLocationIds(locationIds);
            leaseCompStore.setRadiusLeaseCompIds(leaseCompIds);
            saleCompStore.setRadiusSaleCompIds(saleCompIds);
        } else {
            locationStore.setRadiusLocationIds([]);
            leaseCompStore.setRadiusLeaseCompIds([]);
            saleCompStore.setRadiusSaleCompIds([]);
        }

        return () => {
            locationStore.setRadiusLocationIds([]);
            leaseCompStore.setRadiusLeaseCompIds([]);
            saleCompStore.setRadiusSaleCompIds([]);
        };
    }, [locationIds, leaseCompIds, saleCompIds, visible]);
}
